export enum DeliveryServiceType {
  PuntoFijo = 1,
  Mensajeria = 2
}
